export default "__VITE_ASSET__AdSOc_ta__"